/** Оставляет только цифры — целые рубли без копеек. */
export function sanitizeRublesInput(raw: string): string {
  return raw.replace(/\D/g, '');
}

/** Парсит строку рублей в копейки. Пустая строка → null. */
export function parseRublesToKopecks(raw: string): number | null {
  const sanitized = sanitizeRublesInput(raw);
  if (sanitized === '') return null;
  return Number(sanitized) * 100;
}

/** Копейки → строка для поля ввода (целые рубли). */
export function kopecksToRublesInput(kopecks: number): string {
  if (kopecks === 0) return '';
  return String(kopecks / 100);
}
